/* @flow @format */

import { type ContextRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as React from 'react';
import qs from 'qs';

import type { Dispatch, StoreState } from '../redux/types';
import { fetchAgreementBegin } from '../redux/reducer/term';
import { signinBegin } from '../redux/reducer/auth';
import { toJapanTime } from '../utils';
import SplashPage from './SplashPage';
import ZkaiPage from './ZkaiPage';

const timelines = [
  {
    title: 'おすしをつくってわたそう',
    text: 'お客さんの注文どおりにお寿司をつくります。フローチャートを使って条件分岐を含んだプログラムを設計する方法を学びます。',
  },
  {
    title: 'おすしづくりをかんたんにしよう',
    text: 'お寿司を効率的に作るための方法を考えます。プログラミングにおける「繰り返し」の知識を応用しながら、関数の概念に触れていきます。',
  },
  {
    title: 'おすしのつくりかたをせいりしよう',
    text: '数種類のお寿司の作り方の共通点や相違点を整理します。工程を一般化することにより多様な場面に対応できるプログラムを作る土台を養います。',
  },
  {
    title: 'いろいろなちゅうもんにこたえよう',
    text: '売り切れのネタの注文にすばやく対応する方法を考えます。リストを使いながら、複数の条件分岐を的確な順番で処理する重要性を学んでいきます。',
  },
];

type State = {
  loading: boolean,
};

type OwnProps = {|
  ...ContextRouter,
|};

type Props = {
  ...OwnProps,
  signinBegin: typeof signinBegin,
  fetchAgreementBegin: typeof fetchAgreementBegin,

  fetching: boolean,
  active: number | void,
  accepted: boolean,
};

class ZPro3 extends React.Component<Props, State> {
  state = {
    loading: true,
  };

  restoreTitle: ?Function;
  token: string;

  constructor(props: Props) {
    super(props);

    const urlParams = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    if (!urlParams.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
    }
  }

  componentDidMount() {
    const oldTitle = document.title;
    this.restoreTitle = () => {
      document.title = oldTitle;
    };
    document.title = 'Z-pro 小学3年生';
    const urlParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this.token = typeof urlParams.token === 'string' ? urlParams.token : '';
    if (!this.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
      return;
    }

    const { fetchAgreementBegin } = this.props;

    fetchAgreementBegin({
      token: this.token,
      ticketSlug: 'z-pro-3',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });

    this.setState({ loading: false });
  }

  componentWillUnmount() {
    if (this.restoreTitle) this.restoreTitle();
  }

  handleStartClick = () => {
    this.props.signinBegin({
      token: this.token,
      ticketSlug: 'z-pro-3',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });
  };

  render() {
    const { loading } = this.state;
    const { fetching, accepted, active } = this.props;

    if (loading || fetching) return <SplashPage />;
    return (
      <ZkaiPage
        kind="sushi"
        timelines={timelines}
        tagline="Z会小学生コース/小学生タブレットコース 3年生"
        accepted={accepted}
        active={active}
        onStartClick={this.handleStartClick}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch, _: OwnProps) => ({
  signinBegin: (input) => dispatch(signinBegin(input)),
  fetchAgreementBegin: (input) => dispatch(fetchAgreementBegin(input)),
});

function mapStateToProps(state: StoreState) {
  const {
    term: { privacyPolicySigned, termsOfUseSigned, timestamp },
  } = state;

  const fetching = !timestamp;
  const accepted = privacyPolicySigned && termsOfUseSigned;
  let active = undefined;
  if (!fetching) {
    const japanTime = toJapanTime(new Date(timestamp));
    // Date.getMonth() return value in [0, 11]
    const month = japanTime.getUTCMonth() + 1;
    const dayOfMonth = japanTime.getUTCDate();
    if (1 <= month && month <= 3) {
      // the switching date of course 4 is Jan 5th
      if (month === 1 && dayOfMonth < 5) active = 2;
      else active = 3;
    } else if (4 <= month && month <= 6) {
      active = 0;
    } else if (7 <= month && month <= 9) {
      active = 1;
    } else if (10 <= month && month <= 12) {
      active = 2;
    }
  }

  return { fetching, accepted, active };
}

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(ZPro3);
